import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  deliveryType: {
    description: '',
    code: '',
    type: '',
  },
};

export const createDeliveryType = createSlice({
  name: 'createDeliveryType',
  initialState,
  reducers: {
    updateDeliveryTypeInfo: (state, action) => {
      state.deliveryType = action.payload;
    },
    updateDeliveryTypeInfoField: (state, action) => {
      const { field, value } = action.payload;
      state.deliveryType[field] = value;
    },
    clearDeliveryTypeInfo: (state) => {
      state.deliveryType = initialState.deliveryType;
    },
  },
});

export const deliveryTypeDetailSelector = (state) =>
  state.createDeliveryType.deliveryType;
export const {
  updateDeliveryTypeInfo,
  updateDeliveryTypeInfoField,
  clearDeliveryTypeInfo,
} = createDeliveryType.actions;

export const createDeliveryTypeReducer = createDeliveryType.reducer;
export const createDeliveryTypeReducerName = createDeliveryType.name;

export default createDeliveryType.reducer;
